import React, { useState, useEffect } from "react";

const Tooltip = ({ children, content, forceHide }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (forceHide) {
      setIsVisible(false);
    }
  }, [forceHide]);

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => !forceHide && setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
      {isVisible && !forceHide && (
        <div className="absolute z-50 px-3 py-2 text-xs text-white dark:text-gray-900 bg-gray-900/90 dark:bg-white/90 backdrop-blur-xl rounded-lg shadow-xl border border-gray-700/50 dark:border-gray-300/50 bottom-full left-0 -translate-y-2 w-72">
          <div>
            {content}
          </div>
          <div className="absolute w-2 h-2 bg-gray-900/90 dark:bg-white/90 backdrop-blur-xl border-l border-t border-gray-700/50 dark:border-gray-300/50 rotate-45 -bottom-1 left-3"></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
